const isObject = (item: unknown): item is Record<string, unknown> =>
  item !== null &&
  typeof item === 'object' &&
  !Array.isArray(item) &&
  !(item instanceof Date)

function mergeTwo(target: unknown, source: unknown): unknown {
  if (!isObject(source)) return source
  if (!isObject(target)) return { ...source }

  const result: Record<string, unknown> = { ...target }

  for (const key of Object.keys(source)) {
    const sourceVal = source[key]
    const targetVal = target[key]

    if (isObject(sourceVal) && isObject(targetVal)) {
      result[key] = mergeTwo(targetVal, sourceVal)
    } else {
      result[key] = sourceVal
    }
  }

  return result
}

function mergeTwoAndConcat(target: unknown, source: unknown): unknown {
  if (!isObject(source)) return source
  if (!isObject(target)) return { ...source }

  const result: Record<string, unknown> = { ...target }

  for (const key of Object.keys(source)) {
    const sourceVal = source[key]
    const targetVal = target[key]

    if (Array.isArray(sourceVal) && Array.isArray(targetVal)) {
      result[key] = [...targetVal, ...sourceVal]
    } else if (isObject(sourceVal) && isObject(targetVal)) {
      result[key] = mergeTwoAndConcat(targetVal, sourceVal)
    } else {
      result[key] = sourceVal
    }
  }

  return result
}

export function merge<T>(target: T, ...sources: unknown[]): T {
  if (sources.length === 0) return target
  return sources.reduce((acc, src) => mergeTwo(acc, src), target) as T
}

export function mergeAndConcat<T>(target: T, ...sources: unknown[]): T {
  if (sources.length === 0) return target
  return sources.reduce((acc, src) => mergeTwoAndConcat(acc, src), target) as T
}
